<div *ngIf="form" [formGroup]="form">
  <div [ngSwitch]="control.controlType">
    <div class="row">
      <div class="col-md-11">
        <hb-df-textbox *ngSwitchCase="'textbox'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-df-textbox>

        <hb-dynamic-password
          *ngSwitchCase="'password'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-dynamic-password>

        <hb-df-auto-complete-textbox
          *ngSwitchCase="'autocomplete-textbox'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-auto-complete-textbox>

        <hb-df-dropdown
          *ngSwitchCase="'dropdown'"
          [control]="control"
          [formGroup]="form"
          (dropdownChange)="onDropdownChange($event)"
          (onOverrideValue)="overrideValue()"
        ></hb-df-dropdown>

        <hb-df-prime-dropdown
          *ngSwitchCase="'prime-dropdown'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-prime-dropdown>

        <hb-df-prime-multi-select
          *ngSwitchCase="'prime-multi-select'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-prime-multi-select>

        <hb-df-loading-dropdown
          *ngSwitchCase="'loading-dropdown'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-loading-dropdown>

        <hb-df-filter-dropdown
          *ngSwitchCase="'filter-dropdown'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-filter-dropdown>

        <hb-dynamic-number *ngSwitchCase="'number'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-dynamic-number>

        <hb-dynamic-min-max *ngSwitchCase="'minmax'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-dynamic-min-max>

        <hb-df-textarea *ngSwitchCase="'textarea'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-df-textarea>

        <hb-dynamic-rich-text
          *ngSwitchCase="'richtext'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-dynamic-rich-text>

        <hb-df-check-box *ngSwitchCase="'checkbox'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-df-check-box>

        <hb-dynamic-label *ngSwitchCase="'label'" [control]="control" [formGroup]="form"></hb-dynamic-label>

        <hb-df-date-time *ngSwitchCase="'datetime'" [control]="control" [formGroup]="form" (onOverrideValue)="overrideValue()"></hb-df-date-time>

        <hb-dynamic-prime-list-box
          *ngSwitchCase="'prime-listbox'"
          [control]="control"
          [formGroup]="form"
          (clickEvent)="onClickEvent()"
        ></hb-dynamic-prime-list-box>

        <hb-dynamic-auto-complete
          *ngSwitchCase="'autocomplete'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-dynamic-auto-complete>

        <hb-dynamic-auto-complete-double
          *ngSwitchCase="'autocomplete-double'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-dynamic-auto-complete-double>

        <hb-df-dropdown-double
          *ngSwitchCase="'dropdown-double'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-dropdown-double>

        <hb-dynamic-separator *ngSwitchCase="'separator'" [control]="control" [formGroup]="form"></hb-dynamic-separator>

        <hb-dynamic-radio-button
          *ngSwitchCase="'radiobutton'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-dynamic-radio-button>

        <hb-df-multi-select
          *ngSwitchCase="'multi-select'"
          [control]="control"
          [formGroup]="form"
          (onOverrideValue)="overrideValue()"
        ></hb-df-multi-select>

      </div>
      <div class="col-md-1" *ngIf="control.displayLockedAttribute">
        <i class="fa fa-lock"></i>
      </div>
    </div>
  </div>
</div>
